var ENGLISH_DATE_SELECT = {
  invalidDate: 'Invalid Date',
  invalidDateAfter: function invalidDateAfter(date) {
    return "Date entered is before ".concat(date);
  },
  invalidDateBefore: function invalidDateBefore(date) {
    return "Date entered is after ".concat(date);
  },
  invalidDateBetween: function invalidDateBetween(first, second) {
    return "Date is not between ".concat(first, " and ").concat(second);
  },
  invalidDateRequired: 'A date must be entered',
  monthOption00: 'Month',
  monthOption01: 'January',
  monthOption02: 'February',
  monthOption03: 'March',
  monthOption04: 'April',
  monthOption05: 'May',
  monthOption06: 'June',
  monthOption07: 'July',
  monthOption08: 'August',
  monthOption09: 'September',
  monthOption10: 'October',
  monthOption11: 'November',
  monthOption12: 'December'
};
var SPANISH_DATE_SELECT = {
  invalidDate: 'Fecha Inválida',
  invalidDateAfter: function invalidDateAfter(date) {
    return "Fecha entrada es antes de ".concat(date);
  },
  invalidDateBefore: function invalidDateBefore(date) {
    return "la fecha entrada es posterior a ".concat(date);
  },
  invalidDateBetween: function invalidDateBetween(first, second) {
    return "Fecha entrada no es entre ".concat(first, " y ").concat(second);
  },
  invalidDateRequired: 'Una fecha debe ser entrada',
  monthOption00: 'Mes',
  monthOption01: 'Enero',
  monthOption02: 'Febrero',
  monthOption03: 'Marzo',
  monthOption04: 'Abril',
  monthOption05: 'Mayo',
  monthOption06: 'Junio',
  monthOption07: 'Julio',
  monthOption08: 'Agosto',
  monthOption09: 'Septiembre',
  monthOption10: 'Octubre',
  monthOption11: 'Noviembre',
  monthOption12: 'Diciembre'
};
var DATE_SELECT_TRANSLATIONS = {
  'en-US': ENGLISH_DATE_SELECT,
  'es-US': SPANISH_DATE_SELECT
};

export { DATE_SELECT_TRANSLATIONS };
